import { Link } from 'react-router'

export function TerminosPage() {
  return (
    <div className="legal-page">
      <div className="legal-inner">
        <h1 className="legal-title">Términos y Condiciones</h1>

        <section className="legal-section">
          <h2>1. Independencia</h2>
          <p>Hemiciclo funciona de manera completamente autónoma. No recibe financiamiento, instrucciones ni apoyo de ningún gobierno, partido político, parlamentario, ministerio u organización pública o privada.</p>
          <p>Este proyecto se ampara en el derecho constitucional a la libertad de expresión e información (Art. 19 N°12 de la Constitución) y en la Ley N° 20.285 sobre acceso a la información pública.</p>
        </section>

        <section className="legal-section">
          <h2>2. Información sobre parlamentarios</h2>
          <p>Los nombres, partidos y registros de votación que aparecen en Hemiciclo corresponden a información pública sobre el ejercicio de cargos de representación popular. Su publicación está respaldada por el principio de transparencia consagrado en el Art. 8° de la Constitución y la Ley N° 20.285.</p>
        </section>

        <section className="legal-section">
          <h2>3. Fuentes de datos</h2>
          <p>Hemiciclo consume exclusivamente datos publicados por instituciones del Estado:</p>
          <ul>
            <li>Senado de Chile — <a href="https://tramitacion.senado.cl/wspublico/" target="_blank" rel="noopener">tramitacion.senado.cl</a></li>
            <li>Cámara de Diputados — <a href="https://opendata.camara.cl" target="_blank" rel="noopener">opendata.camara.cl</a></li>
            <li>Biblioteca del Congreso Nacional — <a href="https://www.bcn.cl/leychile" target="_blank" rel="noopener">bcn.cl/leychile</a></li>
          </ul>
          <p>No garantizamos que los datos estén completos o libres de errores, ya que dependen de la calidad de las fuentes oficiales.</p>
        </section>

        <section className="legal-section">
          <h2>4. Correcciones</h2>
          <p>Si encuentras un error o quieres reportar un problema, escribe a <a href="mailto:contacto@hemiciclo.cl">contacto@hemiciclo.cl</a>. Nos comprometemos a revisar y responder dentro de 5 días hábiles.</p>
        </section>

        <section className="legal-section">
          <h2>5. Privacidad</h2>
          <p>Hemiciclo utiliza Cloudflare Web Analytics para entender cómo se usa el sitio. Estas métricas son anónimas y agregadas — no identifican personas ni utilizan cookies de seguimiento. Navegar este sitio implica aceptar esta práctica.</p>
        </section>

        <Link to="/" className="legal-back">← Volver al inicio</Link>
      </div>
    </div>
  )
}
